import { BOOKING_URL, roomGallery, rooms } from "../../models/site";
import { useCarouselPresenter } from "../../presenters/useInteractionPresenters";
import { ImageGallery } from "../ImageGallery";
import { SmartImage } from "../SmartImage";
import { PageIntro } from "./PageIntro";

function RoomPhotoCarousel({
  images,
  roomTitle,
  eager = false,
}: {
  images: (typeof rooms)[number]["images"];
  roomTitle: string;
  eager?: boolean;
}) {
  const carousel = useCarouselPresenter(images.length, { autoPlayMs: 6000 });
  const currentImage = images[carousel.index];

  return (
    <div
      className="room-photo-carousel"
      aria-label={`${roomTitle} 房間照片 Room photos`}
      onMouseEnter={carousel.pauseForInteraction}
      onMouseLeave={carousel.resumeAfterInteraction}
      onFocus={carousel.pauseForInteraction}
      onBlur={carousel.resumeAfterInteraction}
    >
      <SmartImage
        name={currentImage.name}
        alt={currentImage.alt}
        width={currentImage.width}
        height={currentImage.height}
        sizes="(max-width: 767px) 100vw, 55vw"
        eager={eager}
      />
      {images.length > 1 && (
        <div className="room-carousel-controls">
          <button
            type="button"
            onClick={carousel.previous}
            aria-label={`${roomTitle} 上一張照片 Previous photo`}
          >
            ←
          </button>
          <span aria-live="polite">
            {String(carousel.index + 1).padStart(2, "0")} /{" "}
            {String(images.length).padStart(2, "0")}
          </span>
          <button
            type="button"
            onClick={carousel.next}
            aria-label={`${roomTitle} 下一張照片 Next photo`}
          >
            →
          </button>
        </div>
      )}
    </div>
  );
}

export function RoomsPage() {
  return (
    <div className="standard-page">
      <PageIntro eyebrow="REST WELL" title="房間" en="ROOMS">
        <p>
          每一張床都留給一夜好眠。<br/>All rooms are simple, comfortable and made for
          a good night’s rest.
        </p>
      </PageIntro>
      <div className="room-list">
        {rooms.map((room, index) => (
          <article
            className={`room-row ${index % 2 ? "reverse" : ""}`}
            key={room.title}
          >
            <RoomPhotoCarousel
              images={room.images}
              roomTitle={`${room.title} ${room.en}`}
              eager={index === 0}
            />
            <div className="room-copy">
              <p className="room-index">0{index + 1}</p>
              <h2>
                {room.title}
                <span>{room.en}</span>
              </h2>
              <ul>
                {room.facts.map((fact) => (
                  <li key={fact}>{fact}</li>
                ))}
              </ul>
              <a
                className="outline-dark"
                href={BOOKING_URL}
                target="_blank"
                rel="noreferrer"
              >
                BOOK NOW
              </a>
            </div>
          </article>
        ))}
      </div>
      <section className="gallery-section">
        <div className="section-heading">
          <p>A CLOSER LOOK</p>
          <h2>
            GALLERY <span>空間照片</span>
          </h2>
        </div>
        <ImageGallery
          images={roomGallery}
          dialogLabel="房間圖片燈箱 Room gallery"
        />
      </section>
    </div>
  );
}
